import { type TranslationTree } from '@/i18n/types';

export const messages = {
  logo: 'Logo da organização',
  logoHint: 'PNG, JPG ou WEBP, até 5 MB. Aparece no app ao lado do nome.',
  logoAlt: 'Logo da organização',
  logoCropTitle: 'Recortar logo',
  displayName: 'Nome público',
  displayNameHint: 'Como os atletas vão ver',
  displayNamePlaceholder: 'Corre PB Eventos',
  legalName: 'Razão social ou nome completo',
  legalNamePlaceholder: 'Corre PB Assessoria Esportiva Ltda',
  taxId: 'CPF ou CNPJ',
  category: 'Tipo de parceiro',
  description: 'Descrição curta',
  optional: 'Opcional',
  descriptionCounter: {
    one: '{{count}} de 280 caracteres',
    other: '{{count}} de 280 caracteres',
  },
  descriptionPlaceholder: 'O que vocês oferecem, onde atuam e há quanto tempo',
  lockedHint: 'Travado após a aprovação. Para corrigir, fale com a Bodyprint',
} satisfies TranslationTree;
